import list from "./list";
const segmentModule = {
  namespaced: true,
  modules: {
    list,
  },
};

export default segmentModule;
